import React from 'react';
import {
  ADDON_SEAT_FEE,
  FEATURE_LITIGATION,
  formatEur,
  MAX_SEATS_PER_INSTANCE,
  MONTHLY_FEE_PREMIUM,
  MONTHLY_FEE_PROFESSIONAL,
  PRODUCT_NAME,
  SETUP_FEE,
  TARIF_PREMIUM,
  TARIF_PROFESSIONAL,
} from '../../../constants';
import { LEGAL_ENTITY, S9_RAO } from '../../landing-templates/t04-dala-orbit/t04LandingShared';

/** Abgestimmt mit PREISLISTE_UND_VERTRAGSANLAGE.md v1.0 FINAL (3.7.2026). */
export const T05_LEGAL_STAND = '3. Juli 2026';

export const T05_LEGAL_TRADEMARK_FOOTNOTE =
  'Orbis – Markenanmeldung ausstehend (kein ®). ARKORBIT® (Wortmarke AT 336 075, Wortbildmarke AT 336 077) eingetragen.';

/** § 3 Zahlung — Preise Orbis-Kanon; Stripe nur Zahlungsweg (Details Datenschutzerklärung, nicht AVV). */
export const T05_LEGAL_PAYMENT_PARAGRAPH = `Tarife gemäß Preisliste: ${TARIF_PROFESSIONAL} ${formatEur(
  MONTHLY_FEE_PROFESSIONAL,
)}/Monat, ${TARIF_PREMIUM} ${formatEur(MONTHLY_FEE_PREMIUM)}/Monat; Setup einmalig ${formatEur(
  SETUP_FEE,
)}; Zusatzsitz ${formatEur(ADDON_SEAT_FEE)}/Monat (max. ${MAX_SEATS_PER_INSTANCE} Sitze pro Instanz). Monatliche Abrechnung im Voraus. Zahlung per Überweisung oder — sofern angeboten — über Stripe (Kreditkarte/SEPA-Lastschrift). Vertrag durch schriftliche Auftragserteilung.`;

export const T05_S9_MARKETING = {
  title: `${S9_RAO} — Verschwiegenheitspflicht`,
  lead:
    'Orbis und ARKORBIT richten Architektur und Betrieb auf die Anforderungen der anwaltlichen Verschwiegenheitspflicht aus — Self-Hosted auf Ihrem EU-Server, ohne US-Cloud-Zwang für Mandantendaten.',
  bullets: [
    'Mit Vertragsabschluss (AGB und AVV) automatisch verbindlicher Bestandteil des Vertragswerks',
    'Zusätzliche schriftliche Bestätigung auf Wunsch möglich und jederzeit nachreichbar',
    'Technische Umsetzung: Edge-Server in der EU, kein Mandanten-PII auf ARKORBIT-Firmenservern',
  ],
  avvNote:
    'Ausführliche vertragliche Regelungen finden Sie im Auftragsverarbeitungsvertrag (AVV, Anhang der AGB). Dieser Hinweis dient der Verständlichkeit auf der Website — kein Rechtsrat.',
};

export const T05LegalTrademarkFootnote: React.FC = () => (
  <p className="t05-legal-modal__fine t05-legal-modal__trademark">{T05_LEGAL_TRADEMARK_FOOTNOTE}</p>
);

export const T05LegalImpressumBody: React.FC = () => (
  <div className="t05-legal-modal__body">
    <div className="t05-legal-modal__grid t05-legal-modal__grid--2">
      <div>
        <div className="t05-legal-modal__box">
          <h4>Medieninhaber</h4>
          <p className="t05-legal-modal__strong">{LEGAL_ENTITY.NAME}</p>
          <p>
            {LEGAL_ENTITY.ADDRESS}
            <br />
            {LEGAL_ENTITY.LOCATION}
            <br />
            Österreich
          </p>
          <div className="t05-legal-modal__meta">
            <p>
              <span>E-Mail:</span> office@arkorbit.at
            </p>
            <p>
              <span>Web:</span> www.arkorbit.at
            </p>
          </div>
        </div>
        <p className="t05-legal-modal__fine">
          Dienstleistungen in der automatischen Datenverarbeitung und Informationstechnik. Entwicklung und
          Vertrieb von Software für juristische Berufe.
        </p>
      </div>
      <div>
        <div className="t05-legal-modal__box">
          <h4>Gewerbe &amp; Aufsicht</h4>
          <ul className="t05-legal-modal__list t05-legal-modal__list--compact">
            <li>
              <strong>Kammer:</strong> WKO Niederösterreich · UBIT
            </li>
            <li>
              <strong>Aufsicht:</strong> BH Tulln
            </li>
            <li>
              <strong>UID:</strong> ATU83006408
            </li>
          </ul>
        </div>
        <p className="t05-legal-modal__fine">
          ODR:{' '}
          <a href="http://ec.europa.eu/odr" target="_blank" rel="noreferrer">
            ec.europa.eu/odr
          </a>
        </p>
      </div>
      <div className="t05-legal-modal__grid-span-2 t05-legal-modal__fine t05-legal-modal__grid t05-legal-modal__grid--2">
        <p>
          <strong>Haftung für Inhalte:</strong> Inhalte mit größter Sorgfalt erstellt. Angebot richtet sich
          ausschließlich an Unternehmer (B2B).
        </p>
        <p>
          <strong>Urheberrecht:</strong> Inhalte unterliegen österr. Urheberrecht. Vervielfältigung nur mit
          schriftlicher Zustimmung.
        </p>
      </div>
    </div>
    <T05LegalTrademarkFootnote />
  </div>
);

export const T05LegalPrivacyBody: React.FC = () => (
  <div className="t05-legal-modal__body">
    <section className="t05-legal-modal__section">
      <h4>1. Verantwortlicher</h4>
      <div className="t05-legal-modal__box">
        <strong>{LEGAL_ENTITY.NAME}</strong>
        <br />
        {LEGAL_ENTITY.ADDRESS}
        <br />
        {LEGAL_ENTITY.LOCATION}, Österreich
        <br />
        office@arkorbit.at
      </div>
    </section>
    <section className="t05-legal-modal__section">
      <h4>2. Verarbeitete Datenarten</h4>
      <ul className="t05-legal-modal__list">
        <li>Bestandsdaten: Name, Unternehmensname, Anschrift</li>
        <li>Kontaktdaten: E-Mail, Telefon</li>
        <li>Zahlungsdaten: Stripe Payments Europe Ltd. (Irland/EU)</li>
        <li>Inhaltsdaten: Audiodiktate, Chat-Verläufe (Self-Hosted, kein Drittanbieter)</li>
      </ul>
    </section>
    <section className="t05-legal-modal__section">
      <h4>3. Dienstleister &amp; Sub-Auftragsverarbeiter</h4>
      <p>
        Unser System ist vollständig <strong className="t05-legal-modal__accent">Self-Hosted</strong> auf Hetzner
        Frankfurt. Keine US-KI-Anbieter.
      </p>
      <div className="t05-legal-modal__grid t05-legal-modal__grid--2">
        {[
          { name: 'Hetzner Online GmbH', info: 'Frankfurt · ISO 27001 · AVV vorhanden' },
          {
            name: 'KI-Engine (Self-Hosted)',
            info: 'Ollama + Mistral + Whisper · Keine Datenübermittlung in die USA',
            accent: true,
          },
          { name: 'Stripe Payments Europe Ltd.', info: 'Irland/EU · Nur Zahlungsabwicklung' },
          {
            name: 'Matrix (Self-Hosted)',
            info: 'matrix.arkorbit.at · E2EE · Keine Metadaten an Dritte',
            accent: true,
          },
        ].map((d) => (
          <div
            key={d.name}
            className={`t05-legal-modal__box${d.accent ? ' t05-legal-modal__box--accent' : ''}`}
          >
            <strong>{d.name}</strong>
            <p className="t05-legal-modal__fine">{d.info}</p>
          </div>
        ))}
      </div>
      <p className="t05-legal-modal__fine">
        <strong className="t05-legal-modal__warn">
          {TARIF_PREMIUM} ({FEATURE_LITIGATION})
        </strong>{' '}
        – Bei Nutzung von Claude Opus (Anthropic): <strong>Doppelte Anonymisierung</strong> – Anwalt
        anonymisiert selbst, ARKORBIT pseudonymisiert vor Versand ein weiteres Mal. Kein Kanzleibezug für
        Anthropic erkennbar.
      </p>
    </section>
    <div className="t05-legal-modal__grid t05-legal-modal__grid--2">
      <section className="t05-legal-modal__section">
        <h4>4. Speicherdauer</h4>
        <p>Nur so lange wie vertraglich nötig (7 Jahre Rechnungen gemäß BAO).</p>
      </section>
      <section className="t05-legal-modal__section">
        <h4>5. Ihre Rechte</h4>
        <p>
          Auskunft, Berichtigung, Löschung jederzeit unter office@arkorbit.at. Beschwerderecht bei der österr.
          Datenschutzbehörde.
        </p>
      </section>
    </div>
    <T05LegalTrademarkFootnote />
  </div>
);

export const T05LegalAgbBody: React.FC = () => (
  <div className="t05-legal-modal__body">
    <div className="t05-legal-modal__grid t05-legal-modal__grid--2">
      <section className="t05-legal-modal__section">
        <h4>§ 1 Geltungsbereich</h4>
        <p>
          Diese AGB gelten für alle SaaS-Leistungen von {LEGAL_ENTITY.NAME}. Ausschließlich B2B. Verbraucher sind
          ausgeschlossen.
        </p>
      </section>
      <section className="t05-legal-modal__section">
        <h4>§ 2 Vertragsgegenstand</h4>
        <p>
          Die Kanzlei-Plattform <strong>{PRODUCT_NAME}</strong> (Self-Hosted). KI-gestützte IT-Infrastruktur. Keine
          Rechtsberatung. Kein sachlicher oder juristischer Erfolg geschuldet.
        </p>
      </section>
      <section className="t05-legal-modal__section">
        <h4>§ 3 Zahlung &amp; Vertrag</h4>
        <p>{T05_LEGAL_PAYMENT_PARAGRAPH}</p>
      </section>
      <section className="t05-legal-modal__section">
        <h4>§ 4 Mitwirkungspflichten</h4>
        <p>Zugangsdaten vertraulich behandeln. Qualität der Eingabedaten liegt beim Kunden.</p>
      </section>
    </div>
    <section className="t05-legal-modal__section t05-legal-modal__highlight t05-legal-modal__highlight--warn">
      <h4>§ 5 Haftung &amp; Prüfpflicht</h4>
      <p>
        KI-Ergebnisse sind maschinell generierte Vorschläge.{' '}
        <strong>
          KI-generierte Inhalte ersetzen keine anwaltliche Beratung. Die Prüfpflicht und Verantwortung für alle
          KI-Outputs liegen ausschließlich beim Nutzer / Rechtsanwalt.
        </strong>{' '}
        Haftung nur für Vorsatz und grobe Fahrlässigkeit.
      </p>
    </section>
    <div className="t05-legal-modal__grid t05-legal-modal__grid--2">
      <section className="t05-legal-modal__section">
        <h4>§ 6 SLA</h4>
        <p>98 % Erreichbarkeit im Jahresmittel angestrebt.</p>
      </section>
      <section className="t05-legal-modal__section">
        <h4>§ 7 Schlussbestimmungen</h4>
        <p>Österreichisches Recht. Gerichtsstand: Österreich.</p>
      </section>
    </div>
    <section className="t05-legal-modal__section t05-legal-modal__box">
      <h4>§ 8 Datenhoheit &amp; Export</h4>
      <p>
        Garantierter Export aller Kundendaten in Standardformaten bei Beendigung; optional Übernahme des
        Serververtrags. Kein Vendor Lock-in.
      </p>
    </section>

    <div className="t05-legal-modal__annex">
      <h3>Anhang 1: Auftragsverarbeitungsvertrag (AVV)</h3>
      <p className="t05-legal-modal__fine">Gemäß Art. 28 DSGVO</p>
      <section className="t05-legal-modal__section">
        <h4>1. Gegenstand</h4>
        <p>Verarbeitung personenbezogener Daten im Auftrag der Kanzlei. Dauer = Laufzeit des Hauptvertrages.</p>
      </section>
      <div className="t05-legal-modal__grid t05-legal-modal__grid--2">
        <section className="t05-legal-modal__section">
          <h4>2. Art der Daten</h4>
          <ul className="t05-legal-modal__list t05-legal-modal__list--compact">
            <li>Mandantendaten</li>
            <li>Falldaten &amp; Kommunikation</li>
            <li>Audiodaten</li>
            <li>Mitarbeiter &amp; Dritte</li>
          </ul>
        </section>
        <section className="t05-legal-modal__section">
          <h4>3. TOMs (Art. 32 DSGVO)</h4>
          <p className="t05-legal-modal__fine">Verschlüsselung, Zugangskontrollen, Zero-Data-Retention bei KI-APIs.</p>
        </section>
      </div>
      <section className="t05-legal-modal__section t05-legal-modal__box">
        <h4>4. Sub-Auftragsverarbeiter</h4>
        <ul className="t05-legal-modal__list t05-legal-modal__list--compact">
          <li>Hetzner Online GmbH (Frankfurt)</li>
          <li>Matrix Homeserver (self-hosted)</li>
          <li className="t05-legal-modal__accent">Keine US-KI-Anbieter</li>
        </ul>
        <p className="t05-legal-modal__fine">
          Zahlungsabwicklung über Stripe Payments Europe Ltd. nur für Zahlungsdaten des Auftraggebers; keine
          Mandantendaten. Details in der Datenschutzerklärung.
        </p>
      </section>
      <section className="t05-legal-modal__section t05-legal-modal__highlight t05-legal-modal__highlight--violet">
        <h4>Rechtliche Bindung (Clickwrap)</h4>
        <p className="t05-legal-modal__fine">
          Durch ausdrückliche Zustimmung im Vertragsabschluss rechtlich bindend. Physische Unterschrift nicht
          erforderlich.
        </p>
      </section>
    </div>
    <T05LegalTrademarkFootnote />
  </div>
);
